<div
  *ngIf="!validFile; else uploadedFile"
  appDrag
  (files)="filesDropped($event)"
  class="flex flex-col items-center justify-center rounded-lg border border-dashed border-gray-300 p-10">
  <input
    type="file"
    accept=".jpg, .jpeg, .png, .pdf, .doc, .docx"
    hidden
    id="file"
    (change)="processFile($event)" />
  <label for="file" class="mb-3">
    <app-icon name="upload-cloud" fontSize="80" color="#939694"></app-icon>
  </label>
  <p class="mb-1 text-sm font-semibold" translate>btn.uploadFileFromYourComputer</p>
  <p class="text-sm text-neutral-500" translate>lbl.dropFile</p>
  <div
    *ngIf="errorMsg && uploadError"
    class="mt-5 flex w-full items-center gap-3 rounded-xl bg-primary-100 p-3 md:w-[343px]">
    <app-icon name="alert-circle-solid" color="#F00125"></app-icon>
    <div>
      <p class="text-sm font-medium">{{ errorMsg }}</p>
    </div>
  </div>
</div>
<ng-template #uploadedFile>
  <div class="flex flex-col items-center justify-center">
    <figure
      *ngIf="preViewImage; else otherFile"
      class="relative mb-4 flex h-[216px] items-center justify-center overflow-hidden rounded-xl bg-black md:w-[343px]">
      <img [src]="preViewImage" alt="Preview Image" class="h-full w-auto object-contain" />
      <div
        (click)="enlargeImage()"
        class="absolute bottom-3 flex cursor-pointer items-center gap-2.5 rounded-lg bg-black bg-opacity-70 p-2">
        <app-icon name="expand" color="#FFFFFF"></app-icon>
        <p class="text-sm text-white" translate>lbl.enlargeImage</p>
      </div>
      <button
        class="absolute right-2 top-2"
        app-icon-button
        name="x"
        size="sm"
        (click)="closeEvent()"></button>
    </figure>
    <ng-template #otherFile>
      <div
        class="flex w-full items-center justify-between rounded-lg border border-neutral-200 p-2 md:w-1/2">
        <div class="flex items-center">
          <div class="mr-4 flex items-center justify-center rounded-full bg-neutral-100 p-2">
            <app-icon name="file-attachment"></app-icon>
          </div>
          <div>
            <p class="mb-1 text-sm">{{ fileInfo.name }}</p>
            <p class="uppercase text-neutral-500">{{ fileInfo.type }}</p>
          </div>
        </div>
        <button app-icon-button name="x" (click)="closeEvent()"></button>
      </div>
    </ng-template>
  </div>
</ng-template>
<ng-container *ngIf="isShowEnlargeImage">
  <div class="z-60 fixed left-0 right-0 top-0 z-50 flex h-full w-full items-center justify-center">
    <div class="relative max-h-full w-full max-w-md p-4">
      <div class="relative rounded-lg bg-white shadow dark:bg-gray-700">
        <button
          (click)="enlargeImage()"
          class="absolute left-5 top-5"
          app-icon-button
          name="x"
          size="sm"></button>
        <div>
          <img [src]="preViewImage" alt="Preview Image" />
        </div>
      </div>
    </div>
  </div>
  <div class="fixed inset-0 z-40 bg-black bg-opacity-50"></div>
</ng-container>
<div class="fixed bottom-0 left-0 mt-10 flex w-full justify-end p-4 md:static md:w-auto md:p-0">
  <button
    class="w-full md:w-auto"
    *ngIf="isValidFile"
    app-button
    (click)="uploadedSuccess()"
    translate>
    btn.submit
  </button>
</div>
